// Services Main Page Content
import { FaLaptopCode, FaInstagram, FaBullhorn, FaBullseye, FaUsers, FaChartLine, FaHeadset, FaDollarSign, FaGem, FaSmile, FaStar } from 'react-icons/fa';

export const servicesContent = {
  hero: {
    title: "خدماتنا التسويقية الشاملة",
    subtitle: "حلول رقمية متكاملة تساعدك على النمو والتميز",
    description: "نقدم لك كل ما تحتاجه لبناء حضور قوي على الإنترنت",
    imageUrl: "https://via.placeholder.com/800x500/1A4D5C/2DD4BF?text=Our+Services"
  },

  mainServices: {
    title: "خدماتنا الرئيسية",
    subtitle: "ثلاث ركائز أساسية لنجاحك الرقمي",
    services: [
      {
        id: 1,
        icon: FaLaptopCode,
        title: "تصميم المواقع",
        description: "نصمم لك موقع إلكتروني احترافي يعكس هويتك ويحقق أهدافك",
        features: [
          "تصميم عصري ومتجاوب",
          "سرعة تحميل فائقة",
          "تحسين محركات البحث (SEO)",
          "لوحة تحكم سهلة الاستخدام"
        ],
        link: "/services/web-design",
        buttonText: "اعرف المزيد",
        image: "https://via.placeholder.com/400x300/1A4D5C/2DD4BF?text=Web+Design"
      },
      {
        id: 2,
        icon: FaInstagram,
        title: "إدارة السوشيال ميديا",
        description: "نُدير حساباتك على منصات التواصل بمحتوى جذاب يزيد تفاعل جمهورك",
        features: [
          "تصميم منشورات احترافية",
          "كتابة محتوى إبداعي",
          "جدولة ذكية للمنشورات",
          "تقارير أداء شهرية"
        ],
        link: "/services/social-media",
        buttonText: "اعرف المزيد",
        image: "https://via.placeholder.com/400x300/1A4D5C/2DD4BF?text=Social+Media"
      },
      {
        id: 3,
        icon: FaBullhorn,
        title: "الإعلانات الممولة",
        description: "نُطلق لك حملات إعلانية فعّالة تستهدف جمهورك وتحقق أفضل عائد على الاستثمار",
        features: [
          "إعداد وإدارة الحملات الإعلانية",
          "استهداف دقيق للجمهور",
          "تصميم المواد الإعلانية",
          "تقارير شاملة ودورية"
        ],
        link: "/services/paid-ads",
        buttonText: "اعرف المزيد",
        image: "https://via.placeholder.com/400x300/1A4D5C/2DD4BF?text=Paid+Ads"
      }
    ]
  },

  whyChooseUs: {
    title: "ما الذي يميز خدماتنا؟",
    subtitle: "نقدم أكثر من مجرد خدمة - نقدم شراكة حقيقية لنجاحك",
    features: [
      {
        id: 1,
        icon: FaBullseye,
        title: "استراتيجية مخصصة",
        description: "كل مشروع له خطة فريدة تناسب أهدافه"
      },
      {
        id: 2,
        icon: FaUsers,
        title: "فريق متخصص",
        description: "خبراء في التصميم، التطوير، والتسويق"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "نتائج قابلة للقياس",
        description: "نتابع الأداء ونحسّنه باستمرار"
      },
      {
        id: 4,
        icon: FaHeadset,
        title: "تواصل مستمر",
        description: "نبقى على تواصل معك في كل مرحلة"
      }
    ]
  },

  additionalReasons: {
    title: "لماذا تختارنا؟",
    reasons: [
      {
        id: 1,
        icon: FaGem,
        title: "جودة استثنائية",
        points: [
          "نعمل بأعلى معايير الجودة",
          "نهتم بأدق التفاصيل",
          "نبدأ العمل فوراً بعد الاتفاق",
          "نلتزم بمواعيد التسليم المحددة",
          "لا تأخير ولا تسويف"
        ],
        closing: "جودة عالية في كل ما نقدمه"
      },
      {
        id: 2,
        icon: FaHeadset,
        title: "دعم فني دائم",
        points: [
          "دعم فني على مدار الساعة",
          "رد سريع على استفساراتك",
          "متابعة مستمرة حتى بعد التسليم",
          "حل المشاكل بسرعة",
          "تواصل سهل عبر واتساب"
        ],
        closing: "لست وحدك، نحن معك في كل خطوة"
      },
      {
        id: 3,
        icon: FaDollarSign,
        title: "أسعار تنافسية",
        points: [
          "أسعار عادلة ومنافسة",
          "باقات متنوعة لكل الأحجام",
          "لا رسوم خفية",
          "قيمة حقيقية مقابل ما تدفعه",
          "خيارات دفع مرنة"
        ],
        closing: "جودة عالية بأسعار معقولة"
      },
      {
        id: 4,
        icon: FaChartLine,
        title: "نلتزم بالنتائج",
        points: [
          "تقارير واضحة وشفافة",
          "نقيس كل شيء ونحسّنه",
          "نركز على العائد على الاستثمار",
          "نعمل بناءً على البيانات وليس التخمين",
          "نحسّن الأداء باستمرار"
        ],
        closing: "هدفنا نجاحك، ليس مجرد إتمام المهمة"
      }
    ]
  },

  stats: {
    title: "إنجازاتنا بالأرقام",
    subtitle: "الأرقام تتكلم",
    items: [
      {
        id: 1,
        icon: FaBullseye,
        number: "+150",
        label: "مشروع ناجح"
      },
      {
        id: 2,
        icon: FaSmile,
        number: "+120",
        label: "عميل راضٍ"
      },
      {
        id: 3,
        icon: FaChartLine,
        number: "+500%",
        label: "متوسط نمو المتابعين"
      },
      {
        id: 4,
        icon: FaStar,
        number: "4.9/5",
        label: "تقييم العملاء"
      }
    ]
  },

  cta: {
    title: "ما هي الخدمة المناسبة لمشروعك؟",
    subtitle: "تواصل معنا الآن وسنساعدك في اختيار الحل الأمثل",
    buttonText: "استشارة مجانية عبر واتساب 💬"
  }
};
